import { Filter, Search } from "lucide-react";

import { capabilityStates, type GraphMode, type GraphSnapshot } from "../../domain/model";

interface Props {
  snapshot: GraphSnapshot;
  mode: GraphMode;
  query: string;
  layer: string;
  state: string;
  projectId: string;
  onMode: (mode: GraphMode) => void;
  onQuery: (value: string) => void;
  onLayer: (value: string) => void;
  onState: (value: string) => void;
  onProject: (value: string) => void;
}

const modes: GraphMode[] = ["STACK", "PROJECT", "EVIDENCE", "LEARNING"];

export function GraphControls(props: Props) {
  const layers = Array.from(new Set(props.snapshot.nodes.map((node) => node.layer)));
  return (
    <section className="graph-controls" aria-label="Graph controls">
      <div className="filter-row">
        <div className="filter-console-mark"><Filter size={16} aria-hidden="true" /><span>GRAPH FILTERS</span></div>
        <label className="graph-filter"><span><b>01</b> Layer</span><select value={props.layer} onChange={(event) => props.onLayer(event.target.value)}><option value="">ALL LAYERS</option>{layers.map((item) => <option key={item}>{item}</option>)}</select></label>
        <label className="graph-filter"><span><b>02</b> Capability state</span><select value={props.state} onChange={(event) => props.onState(event.target.value)}><option value="">ALL STATES</option>{capabilityStates.map((item) => <option key={item}>{item}</option>)}</select></label>
        <label className="graph-filter"><span><b>03</b> Project</span><select value={props.projectId} onChange={(event) => props.onProject(event.target.value)}><option value="">ALL PROJECTS</option>{props.snapshot.projects.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}</select></label>
      </div>
      <div className="graph-control-secondary">
        <div className="segmented-control" aria-label="Graph view mode">
          {modes.map((mode) => (
            <button key={mode} className={props.mode === mode ? "active" : ""} onClick={() => props.onMode(mode)} aria-pressed={props.mode === mode}>
              {mode}
            </button>
          ))}
        </div>
        <label className="search-field">
          <Search size={16} aria-hidden="true" />
          <span className="sr-only">Search nodes</span>
          <input value={props.query} onChange={(event) => props.onQuery(event.target.value)} placeholder="Search system" />
        </label>
      </div>
    </section>
  );
}
